import React from 'react'
import { useAtom } from 'jotai'
import Classnames from 'classnames'

// helper functions
import { returnValue } from '@/utils/op-types/helperFunctions'

// store
import {
  isBuilder,
  manifestStatic,
  pageContentStatic,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
} from '@/utils/op-types/store'

// block renderer
import BlockRenderer from '@/components/optypes/frontend/BlockRenderer'

// block builder tools
import StaticContentWrapper from '@/components/optypes/frontend/StaticContentWrapper'
import AddBlockBuilder from '@/components/optypes/frontend/AddBlockBuilder'

import DragWrapper from '@/components/optypes/headlesss-components/DragWrapper'
import OnepagerFooter from '@/components/optypes/headlesss-components/OnepagerFooter'

import dynamic from 'next/dynamic'

const Scrollbars = dynamic(() => import('react-custom-scrollbars'), {
  ssr: false,
})

const KanbanBoard = dynamic(
  () =>
    import('@/components/optypes/frontend/SimpleKanban/components/KanbanBoard'),
  { ssr: false }
)

// blocks
// import Block1 from '@/components/optypes/frontend/SimpleKanban/blocks/Block1'

const Components = {
  kanbanboard: KanbanBoard,
}

const MainComponentRenderer = () => {
  const [builder] = useAtom(isBuilder)
  // manifest settings
  const [opStatic] = useAtom(manifestStatic)
  const [opDesign] = useAtom(manifestDesign)
  const [opBlocks] = useAtom(manifestBlocks)
  // custom page settings
  const [pageStatic] = useAtom(pageContentStatic)
  const [pageDesign] = useAtom(pageContentDesign)
  const [pageBlocks] = useAtom(pageContentBlocks)

  return (
    <div className="p-0 bg-gray-100 min-h-screen">
      {/* header */}

      <div className="px-20 py-20 bg-green-500">
        <div className="flex items-center relative z-10">
          {/* headline / subheadline */}
          <div
            className={Classnames({
              'w-3/4 pr-12':
                !returnValue('videourl', opStatic, pageStatic) &&
                !returnValue('imgurl', opStatic, pageStatic),
              'w-1/2 pr-12':
                returnValue('videourl', opStatic, pageStatic) ||
                returnValue('imgurl', opStatic, pageStatic),
            })}
          >
            <h1
              className={Classnames('font-bold text-6xl', {
                appTitleItem:
                  returnValue('herofont', opDesign, pageDesign) == 'sans',
              })}
              style={{
                color: returnValue('headlinetextcolor', opDesign, pageDesign),
              }}
            >
              <StaticContentWrapper contentKey="headline">
                {returnValue('headline', opStatic, pageStatic)}
              </StaticContentWrapper>
            </h1>
            <div className="mt-4 mb-6 text-xl font-medium">
              <StaticContentWrapper contentKey="subheadline">
                {returnValue('subheadline', opStatic, pageStatic)}
              </StaticContentWrapper>
            </div>
          </div>

          <div
            className={Classnames({
              'w-1/2':
                returnValue('videourl', opStatic, pageStatic) ||
                returnValue('imgurl', opStatic, pageStatic),
            })}
          >
            {/* video */}
            {returnValue('videourl', opStatic, pageStatic) && (
              <div className="player-wrapper rounded shadow-lg overflow-hidden mb-8">
                <ReactPlayer
                  controls={false}
                  playing={false}
                  width="100%"
                  height="100%"
                  className="react-player"
                  url={returnValue('videourl', opStatic, pageStatic)}
                />
              </div>
            )}

            {/* img */}
            {returnValue('imgurl', opStatic, pageStatic) && (
              <img
                src={returnValue('imgurl', opStatic, pageStatic)}
                alt=""
                className="rounded shadow-lg mb-8"
              />
            )}
          </div>
        </div>
      </div>

      {/* example of blocks  */}
      <div className="px-20 py-10  relative z-10 grid grid-cols-3 gap-6 -mt-16">
        <DragWrapper>
          {pageBlocks.map((block, index) => (
            <BlockRenderer
              key={index}
              index={index}
              Components={Components}
              block={block}
            />
          ))}
        </DragWrapper>
      </div>

      {/* add block button builder */}
      {builder && (
        <div className="mt-2 mx-20">
          <AddBlockBuilder btnText="Add Board" />
        </div>
      )}
    </div>
  )
}

export default MainComponentRenderer
